import React, { useMemo } from 'react';
import { generatePath } from 'react-router';

import { DisabledNavLink } from '../../common/DisabledNavLink';

import { campaignMenu } from '../../../constants';

import s from './NewCampaignMenu.module.scss';
import { MenuOptions } from '../../common/MenuOptions';
import { campaignSelector, createNewAdSet } from '../../../store/data';
import { useSelector } from 'react-redux';
import { SvgIcon } from '../../../components/common/SvgIcon';

const NewCampaignMenu = ({
  campaignId,
  mode,
  stickyMenuItem,
  activeCampaign,
  adSets,
  isArchived,
}) => {
  const campaign = useSelector(campaignSelector);
  const createNav = campaignMenu.menuItems.find((menuItem) => menuItem.name === 'Campaign');
  const isCreated = useMemo(() => campaign.isCreated, [campaign.isCreated]);
  const isDisabled = useMemo(() => isArchived, [isArchived]);

  const campaignName = useMemo(() => {
    return activeCampaign.id === campaign.id ? activeCampaign.name : campaign.name;
  }, [activeCampaign.id, campaign.id, campaign.name, activeCampaign.name]);

  return (
    <div className={s['campaign-menu']}>
      <div className={s['campaign-menu__item']}>
        <DisabledNavLink
          isOpen
          isDisabled={isDisabled}
          to={isCreated ? generatePath(createNav.editPath, { cid: campaignId }) : createNav.path}
        >
          {campaign.isDirty && <SvgIcon name="important" />}
          <span>{campaignName || 'New Campaign'}</span>
        </DisabledNavLink>

        <MenuOptions
          name="Campaign"
          createFunction={createNewAdSet}
          type="campaign"
          campaign={campaign}
          campaignId={campaignId}
          isDisabled={isDisabled}
          isOpen
        />
      </div>
      <ul className={s['campaign-submenu']}>
        {createNav.submenuItems.map((submenuItem) => (
          <li key={submenuItem.fragment} className={s['campaign-submenu__item']}>
            <DisabledNavLink
              to={
                isCreated
                  ? generatePath(submenuItem.editPath, { cid: campaignId })
                  : submenuItem.path
              }
              fragment={submenuItem.fragment}
              stickyMenuItem={stickyMenuItem}
              isOpen
              isDisabled={isDisabled}
            >
              {submenuItem.name}
            </DisabledNavLink>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default NewCampaignMenu;
